// extracted by mini-css-extract-plugin
export default {"transaction":"transaction_transaction__Sb0Mq","transactionGroup":"transaction_transactionGroup__z2cXT"};